import * as PleasedApi from '@/common/api/api.pleased';
import { platform } from './bridge';

export const OpenHelpEntry = {
  PLEASED_FLOATING_BUTTON: 'pleased floating button', // added by us to handle floating button case

  UNKNOWN: 'unknown',
  BVN: 'bvn',
  RESET_PIN: 'reset pin',
  SELF_EXCLUSION: 'self exclusion',
  ME: 'me',
  TRANSACTION: 'transaction',
  LIVE_CHAT: 'live chat',
  OTP: 'otp',
  ACCOUNT_REACTIVATE: 'account reactivate',
  ACCOUNT_DEACTIVATE: 'account deactivate',
  CHANGE_PASSWORD: 'change password',
  FORGET_PASSWORD: 'forget password',
  CHANGE_PHONE: 'change phone',
  MISMATCH_NAME_UPLOAD: 'mismatch name upload',
  LOGIN: 'login',
  SUPPORTER: 'supporter',
  PIN_LOCKED: 'pin locked',
  DEPOSIT: 'deposit',
  WITHDRAW: 'withdraw',
  TWO_FA: 'two fa',
  HELP: 'help',
  SPORTY_SOCCER: 'sporty soccer',
} as const;

export type OpenHelpEntryType = typeof OpenHelpEntry[keyof typeof OpenHelpEntry];

const OpenHelpEntryToApiOpenHelpEntry = {
  [OpenHelpEntry.PLEASED_FLOATING_BUTTON]: 'PLEASED_FLOATING_BUTTON',
  [OpenHelpEntry.UNKNOWN]: 'UNKNOWN',
  [OpenHelpEntry.BVN]: 'BVN',
  [OpenHelpEntry.RESET_PIN]: 'RESET_PIN',
  [OpenHelpEntry.SELF_EXCLUSION]: 'SELF_EXCLUSION',
  [OpenHelpEntry.ME]: 'ME',
  [OpenHelpEntry.TRANSACTION]: 'TRANSACTION',
  [OpenHelpEntry.LIVE_CHAT]: 'LIVE_CHAT',
  [OpenHelpEntry.OTP]: 'OTP',
  [OpenHelpEntry.ACCOUNT_REACTIVATE]: 'ACCOUNT_REACTIVATE',
  [OpenHelpEntry.ACCOUNT_DEACTIVATE]: 'ACCOUNT_DEACTIVATE',
  [OpenHelpEntry.CHANGE_PASSWORD]: 'CHANGE_PASSWORD',
  [OpenHelpEntry.FORGET_PASSWORD]: 'FORGET_PASSWORD',
  [OpenHelpEntry.CHANGE_PHONE]: 'CHANGE_PHONE',
  [OpenHelpEntry.MISMATCH_NAME_UPLOAD]: 'MISMATCH_NAME_UPLOAD',
  [OpenHelpEntry.LOGIN]: 'LOGIN',
  [OpenHelpEntry.SUPPORTER]: 'SUPPORTER',
  [OpenHelpEntry.PIN_LOCKED]: 'PIN_LOCKED',
  [OpenHelpEntry.DEPOSIT]: 'DEPOSIT',
  [OpenHelpEntry.WITHDRAW]: 'WITHDRAW',
  [OpenHelpEntry.TWO_FA]: 'TWO_FA',
  [OpenHelpEntry.HELP]: 'HELP',
  [OpenHelpEntry.SPORTY_SOCCER]: 'SPORTY_SOCCER',
};

export type ApiOpenHelpEntry = typeof OpenHelpEntryToApiOpenHelpEntry[keyof typeof OpenHelpEntryToApiOpenHelpEntry];

export const getApiOpenHelpEntry = (openHelpEntry: OpenHelpEntryType) => {
  if (!OpenHelpEntryToApiOpenHelpEntry[openHelpEntry]) {
    console.error(`OpenHelpEntryToApiOpenHelpEntry[${openHelpEntry}] is not defined`);
    return 'UNKNOWN';
  }

  return OpenHelpEntryToApiOpenHelpEntry[openHelpEntry];
};

export const sendEntryLog = async (pageSource: OpenHelpEntryType) => {
  const adaptedPageSource = getApiOpenHelpEntry(pageSource);
  const url = (window.location !== window.parent.location)
    ? document.referrer
    : document.location.href;

  await PleasedApi.sendEntryLog({
    entryType: adaptedPageSource,
    url,
    device: platform,
  });
};
